import React, { useEffect, useState } from 'react';
import UseInput from '../../../../Hooks/UseInput';
import TableCatalogueContainer from './TableCatalogueContainer';
import Btn from '../../../../Components/Btn';
import SelectCustom from '../../../../Components/SelectCustom';
import SelectDropdown from '../../../../Components/SelectDropdown';
import EmptyState from '../../../../Components/EmptyState';
import FilterSearchProductFeedContainer from './FilterSearchProductFeedContainer';
import Panel from '../../../../Components/Panel';
import SearchBar from '../../../../Components/SearchBar';
import SpinnerWheel from '../../../../Components/SpinnerWheel';
import './CatalogueProductFeedContainer.css';
import SearchProductFeedServices from '../../../../Services/SearchProductFeed';
import { ProductFields, ProductRequestResult, ProductRequestResultProduct, SearchRequest } from '../../../../Services/SearchProductFeedTypes';
import ProductFeedConfigurationServices, { ProductFeedTenantConfig } from '../../../../Services/ProductFeedConfigurationServices';

export function transformConfigToList(obj: { [key: string]: ProductFeedTenantConfig } | undefined) {
	const arrayOfTenantsAndConfigs = ([] as any);
	for (const property in obj) {
		const currentObj = {
			key: property,
			feeds: ([] as any[]),
			links: obj[property]._links
		};
		const objToWork = obj[property].sources;
		for (const property in objToWork) {
			const objLinkFeed = {
				...objToWork[property],
				label: objToWork[property].type,
				id: objToWork[property].id,
				resourceIdentifier: objToWork[property].resourceIdentifier,
				// link : objToWork[property]._links
			};
			currentObj.feeds.push(objLinkFeed);
		}
		arrayOfTenantsAndConfigs.push(currentObj);
	}
	return arrayOfTenantsAndConfigs;
}
const urlNewFeed = '/ProductFeed/Edit';

type CatalogueProductFeedContainerType = {
	accountId: string,
	authServices,
	tenantSelected,
	setTenantSelected,
	services: ProductFeedConfigurationServices,
	systemServices,
	$http
}

export default function CatalogueProductFeedContainer({
	accountId,
	authServices,
	tenantSelected,
	setTenantSelected,
	services,
	systemServices,
	$http
}: CatalogueProductFeedContainerType) {

	const [productsPage, setProductsPage] = useState<ProductRequestResultProduct[]>([]);
	const [hasPrevious, setHasPrevious] = useState<boolean>(false);
	const [hasNext, setHasNext] = useState<boolean>(false);
	const [pageNumber, setPageNumber] = useState<number>(1);
	const [advancedSearchIsOpened, setAdvancedSearchIsOpened] = useState<boolean>(false);
	const [pageSize, setPageSize] = useState<number>(10);
	const [isReloading, setIsRealoading] = useState<boolean>(true);
	const [advancedSearchIsActive, setAdvancedSearchIsActive] = useState<boolean>(false);
	const [catalogueIsEmpty, setCatalogueIsEmpty] = useState<boolean>(false);
	const [objectOfFilterForQuerySearch, setObjectOfFilterForQuerySearch] = useState();
	const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

	const INITIAL_STATE = { elem: '' };
	const { value, handleChange } = UseInput(INITIAL_STATE);
	const [tenantsList, setTenantsList] = useState<string[]>([]);

	const currentUser = authServices.GetAuthenticatedUser();
	const [isAdmin, setisAdmin] = useState(false);

	const allowAdvancedSearch = false;

	const searchServices = new SearchProductFeedServices($http, authServices, accountId);

	useEffect(() => {
		const isAdminTest = currentUser && currentUser.Role === 'Admin';
		setisAdmin(isAdminTest);
	}, []);


	const selectTenant = (v) => {
		setTenantSelected(v);
	};

	useEffect(() => {
		services.getSummary(
			success => {
				const list = transformConfigToList(success?.tenantConfigs);
				const listKeytenant = list.map(t => t.key !== '' 
					? { value: t.key, label: t.key } 
					: { value: t.key, label: 'Default' });
				setTenantsList(listKeytenant);
			},
			(error, err) => {
				console.error(error, 'err :', err);
			}
		);
	}, []);


	const queryProductPage = () => {
		//$('[title]').tooltip();
		setIsRealoading(true);

		const onSuccess = (response: ProductRequestResult): void => {
			setIsRealoading(false);
			const products = response.products;

			setHasPrevious(pageNumber > 1);
			setHasNext(response.offset + pageSize < response.totalCount);
			setProductsPage(products);

			if (isFirstRender) {
				if (products.length === 0) {
					setCatalogueIsEmpty(true);
				}
				setIsFirstRender(false);
			}
		};
		const onError = (e) => {
			setIsRealoading(false);
			console.log('err', e);
			systemServices.showError('An error occured');
		};

		const onCatalogNotFound = () => {
			setCatalogueIsEmpty(true);
			setIsRealoading(false);
		};

		const request: SearchRequest = {
			limit: pageSize,
			offset: (pageNumber - 1) * pageSize,
			requestedFields: [ProductFields.Standard],
			searchTerm: value?.elem ? value.elem : null
		};

		tenantSelected
			? searchServices.postSearchWithTenant(request, tenantSelected, onSuccess, onError, onCatalogNotFound)
			: searchServices.postSearchEmptyTenant(request, onSuccess, onError, onCatalogNotFound);
	};
	useEffect(() => {
		queryProductPage();
		setAdvancedSearchIsActive(false);
	}, []);

	const handleClickOnNext = () => {
		setPageNumber(c => c + 1);
	};

	const handleClickOnPrevious = () => {
		setPageNumber(c => c - 1);
	};

	useEffect(() => {
		queryProductPage();
	}, [pageNumber, pageSize, tenantSelected]);


	const handleClickOnSearchqueryAdvanced = () => {
		setAdvancedSearchIsActive(true);
		queryProductPage();
	};

	const changePageSize = (e) => {
		const newPageSize = parseInt(e.target.value);
		setPageSize(newPageSize);
	};

	const pageSizeOptions = [
		{ value: 10, label: 10 },
		{ value: 20, label: 20 },
		{ value: 30, label: 30 },
		{ value: 40, label: 40 },
		{ value: 50, label: 50 },
	];


	const closeAdvancedSearch = () => {
		setAdvancedSearchIsOpened(false);
	};
	const deactivateAdvancedSearchMode = () => {
		setAdvancedSearchIsActive(false);
		queryProductPage();
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			queryProductPage();
		}, 1000);
		return () => {
			clearTimeout(timer);
		};
	}, [value]);

	return (
		<>
			<Panel
				isOpen={advancedSearchIsOpened}
				onClose={() => closeAdvancedSearch()}
				side="right"
				width="730">
				<div className="panel_header"> Advanced Search</div>
				<FilterSearchProductFeedContainer
					//setSearchValue={(e) => setSearchValue(e)}
					setClickOnSearchqueryAdvanced={() => handleClickOnSearchqueryAdvanced()}
					objectOfFilterForQuerySearch={objectOfFilterForQuerySearch}
					setObjectOfFilterForQuerySearch={(e) => setObjectOfFilterForQuerySearch(e)}
					closeThePannel={closeAdvancedSearch}
				/>
			</Panel>

			{(!catalogueIsEmpty || tenantsList.length > 1) &&
				<div className={catalogueIsEmpty ? 'page_block_header has_border flex' : 'page_block_header flex'}>
					<div className="flex_item_full">
						{tenantsList.length > 1 &&
							<span className='mr_15'>
								<SelectDropdown
									label='Tenant'
									labelPosition='inner'
									optionsList={tenantsList}
									value={tenantSelected ? tenantSelected : ''}
									placeHolder='Select a tenant'
									onChange={(v) => selectTenant(v)}
								/>
							</span>
						}
						{!catalogueIsEmpty &&
							<>
								<SearchBar
									onChangeValue={(e) => { setPageNumber(1); handleChange(e); }}
									valueInSearchBar={value.elem}
									placeholder={advancedSearchIsActive ? 'Advanced search' : 'Search for a product name or ID'}
									name="elem"
									width={'xl'}
									size={'l'}
									disabled={advancedSearchIsActive}
								/>
								{isAdmin && allowAdvancedSearch &&
									<span className='ml_5'>
										{advancedSearchIsActive &&
											<Btn
												message={'Reset advanced search'}
												icon={'fas fa-ban'}
												style="ghost"
												color="grey"
												horizontalSize="xs"
												onClick={() => deactivateAdvancedSearchMode()}
											/>
										}
										<Btn
											message={advancedSearchIsActive ? 'Update advanced search' : 'Advanced search'}
											icon={advancedSearchIsActive ? 'fas fa-pen' : ''}
											style="ghost"
											color="grey"
											horizontalSize="xs"
											onClick={() => setAdvancedSearchIsOpened(true)}
										/>
									</span>
								}
							</>
						}
					</div>
				</div>
			}

			{catalogueIsEmpty &&
				<EmptyState
					icon="fas fa-book"
					title="Catalog is empty"
					text={<>Connect your product feed to supply the catalog, <br />it is used for many features.</>}
					verticalSize='xl'
					textSize='l'
					primaryAction={
						<Btn
							href={`${urlNewFeed}${location.search || `?id=${accountId}`}&tenant=${tenantSelected || ''}`}
							message="New product feed"
						/>
					}
				/>
			}

			{productsPage && productsPage.length === 0 && !catalogueIsEmpty &&
				<EmptyState
					title="No result for this search"
					text="Try to search another term"
					verticalSize='xl'
					textSize='l'
				/>
			}

			{productsPage && productsPage.length !== 0 &&
				<>
					<TableCatalogueContainer
						data={productsPage}
					/>
					<div className="footer_product_feed_catalogue">
						<div>
							<SelectCustom
								name="totalArticles"
								optionsList={pageSizeOptions}
								onChangeFunction={(e) => changePageSize(e)}
								value={pageSize}
								autoWidth={true}
							/>
							<span className='ml_10 grey_2'>items per page</span>
						</div>
						<div>
							{
								hasPrevious &&
								<Btn
									onClickFunction={() => handleClickOnPrevious()}
									message="Previous"
								/>
							}
							{
								hasNext &&
								<Btn
									onClickFunction={() => handleClickOnNext()}
									message="Next"
								/>
							}
						</div>
					</div>
				</>
			}
			{isReloading && <SpinnerWheel />}
		</>
	);
}
